const idsToHex = {
  'reviews': 'var(--color-1)',
  'social': 'var(--color-2)',
  'listings': 'var(--color-3)',
  'rankings': 'var(--color-4)',
  'competitors': 'var(--color-5)',
};

export const getColor = scorePath => {
  const shortPath = scorePath && scorePath.split('.')[0] // get the top level component
  return idsToHex[shortPath] || 'red' // error red - hopefully developer / QA will notice the red
}
